<template>
  <v-layout class="auth-wrapper">
    <v-row class="fill-height" justify="center" align="center" no-gutters>
      <v-col cols="12" md="5">
        <div
          class="d-flex flex-column fill-height justify-center overflow-y-auto pa-6 pa-md-12"
        >
          <div class="d-flex align-center justify-center mb-6">
            <v-img
              :src="require('@/assets/logotype.png')"
              max-width="12rem"
              max-height="3rem"
              contain
            />
          </div>

          <router-view />
        </div>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
export default {
  name: "Auth",
};
</script>

<style lang="scss" src="./style.scss" scoped />
